import ContentsBase from './ContentsBase';
import LegendUKMET from '../legend/LegendUKMET';
import { formatBaseTime, formatValidTime } from "../../../utils/FPEUtils";
import { WX_ID_UKMET } from "../../../store/WeatherContentsState";

class ModelUKMET extends ContentsBase {
  static NAME = WX_ID_UKMET;
  static BASETIME_RANGE = 48 * 60 * 60 * 1000;
  static VALIDTIME_RANGE = 48 * 60 * 60 * 1000;
  static UKMET_CHANGE_ALL = 'UKMET_change_all';
  static UKMET_EQV_PT = 'EqvPT';
  static UKMET_ISOTACH = 'Isotach';
  static UKMET_ISOTHERM = 'Isotherm';
  static UKMET_TMINUS_TD = 'TMinusTD';
  static UKMET_TROPOPAUSE = 'Tropopause';
  static UKMET_VWS = 'VWS';
  static UKMET_WIND = 'Wind';
  prevValidtime;
  contentsVisibleState = {
    EqvPT: true,
    Isotach: true,
    Isotherm: true,
    TMinusTD: true,
    Tropopause: true,
    VWS: true,
    Wind: true
  };
  setRevision;

  constructor(setRevision) {
    super('UKMET', 'UKMET', 'Model_UKMET');
    this.setRevision = setRevision;
  }

  parseTimelist() {
    const fullList = this.dataReference.query("timelist").value();
    this.validtimeList = this._parseTimelist(fullList, ModelUKMET.BASETIME_RANGE, ModelUKMET.VALIDTIME_RANGE);
    if(this.prevValidtime) {
      if(this.isDiffPrevDataBaseValid()) {
        this.setRevision()
      }
    }
    this.prevValidtime = JSON.parse(JSON.stringify(this.validtimeList));
  }

  getOpt(date, fpMode) {
    return new Promise(resolve => {
      const makeOpt = () => {
        this.shownTime = this.getValidtimeClosestToTheDateForBaseValid(date, fpMode);
        return {
          Model: {
            Basetime: this.shownTime.basetime,
            Element: {
              ...this.contentsVisibleState
            },
            Name: "UKMET",
            Validtime: this.shownTime.validtime,
            Visible: this.isVisible()
          }
        }
      }
      if (this.updated) {
        resolve(makeOpt());
      } else {
        const intervalId = setInterval(() => {
          if (!this.updated) return;
          clearInterval(intervalId);
          resolve(makeOpt());
        }, 500);
      }
    });
  }

  getLegend() {
    return {
      id: ModelUKMET.NAME,
      label: 'UKMET',
      component: LegendUKMET,
      contents: this
    }
  }

  getTimeInformation() {
    return {
      id: ModelUKMET.NAME,
      label: 'UKMET',
      baseTime: this.shownTime ? formatBaseTime(this.shownTime.basetime) : "---",
      validTime: this.shownTime ? formatValidTime(this.shownTime.validtime[0]) : "---"
    }
  }

  getContentsVisibleState() {
    return this.contentsVisibleState;
  }

  setContentsVisible(name, visible) {
    this.contentsVisibleState[name] = visible;
  }
}

export default ModelUKMET;